import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Web Developer Portfolio" link="https://soumyadeep-portfolio.netlify.app/" bg="linear-gradient(90deg, rgba(20,246,54,1) 10%, rgba(59,76,125,0.7766456924566701) 100%)" mdxType="ProjectCard">
  This project is my personal portfolio.
    </ProjectCard>
    <ProjectCard title="Covid19 Info" link="https://github.com/soumyadeepsinha/covid19pandemic.info" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  This is a project to show Covid-19 Information.
    </ProjectCard>
    <ProjectCard title="Restaurant website" link="https://github.com/soumyadeepsinha/MyRestaurant" bg="linear-gradient(to right top, #051937, #004d7a, #008793, #00bf72, #a8eb12)" mdxType="ProjectCard">
  Every Restaurant business needs to have a website.
    </ProjectCard>
    <ProjectCard title="Instagram Post Scrapper Bot" link="https://github.com/soumyadeepsinha/InstagramScrapperBot" bg="linear-gradient(90deg, rgba(75,63,251,1) 0%, rgba(205,27,63,1) 90%)" mdxType="ProjectCard">
  Python has a most useful feature - Scrape.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      